import { E as w } from "./element-CV9utnHJ.js";
import { e as A, i as E, t as M } from "./directive-oAbCiebi.js";
import { M as b, u as p, v, h as x, p as j } from "./directive-helpers-CyPtA1_i.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const k = (s, c, a) => {
  const h = /* @__PURE__ */ new Map();
  for (let e = c; e <= a; e++) h.set(s[e], e);
  return h;
}, I = A(class extends E {
  constructor(s) {
    if (super(s), s.type !== M.CHILD) throw Error("repeat() can only be used in text expressions");
  }
  dt(s, c, a) {
    let h;
    a === void 0 ? a = c : c !== void 0 && (h = c);
    const e = [], i = [];
    let l = 0;
    for (const u of s) e[l] = h ? h(u, l) : l, i[l] = a(u, l), l++;
    return { values: i, keys: e };
  }
  render(s, c, a) {
    return this.dt(s, c, a).values;
  }
  update(s, [c, a, h]) {
    const e = b(s), { values: i, keys: l } = this.dt(c, a, h);
    if (!Array.isArray(e)) return this.ut = l, i;
    const u = this.ut ?? (this.ut = []), f = [];
    let m, $, t = 0, o = e.length - 1, r = 0, n = i.length - 1;
    for (; t <= o && r <= n; ) if (e[t] === null) t++;
    else if (e[o] === null) o--;
    else if (u[t] === l[r]) f[r] = p(e[t], i[r]), t++, r++;
    else if (u[o] === l[n]) f[n] = p(e[o], i[n]), o--, n--;
    else if (u[t] === l[n]) f[n] = p(e[t], i[n]), v(s, f[n + 1], e[t]), t++, n--;
    else if (u[o] === l[r]) f[r] = p(e[o], i[r]), v(s, e[t], e[o]), o--, r++;
    else if (m === void 0 && (m = k(l, r, n), $ = k(u, t, o)), m.has(u[t])) if (m.has(u[o])) {
      const d = $.get(l[r]), y = d !== void 0 ? e[d] : null;
      if (y === null) {
        const g = v(s, e[t]);
        p(g, i[r]), f[r] = g;
      } else f[r] = p(y, i[r]), v(s, e[t], y), e[d] = null;
      r++;
    } else x(e[o]), o--;
    else x(e[t]), t++;
    for (; r <= n; ) {
      const d = v(s, f[n + 1]);
      p(d, i[r]), f[r++] = d;
    }
    for (; t <= o; ) {
      const d = e[t++];
      d !== null && x(d);
    }
    return this.ut = l, j(s, f), w;
  }
});
export {
  I as c
};
